import lang from "@/views/modules/RelatedLinks/language/en";

//import Editor from '@tinymce/tinymce-vue';

export default {
    name: "new-relatedLink",
   
    components: {
     //   'editor': Editor,
    },
    data() {
        return {
            loading: true,
            relatedLink: {},
            lang:[],
        }
    },
    mounted() {
        this.lang = lang;
    },
    methods: {
        saveRelatedLink() {
            const self = this;
            self.loading = true;
            axios.post('api/modules/relatedLinks', self.relatedLink).then(function (response) {
                self.loading = false;
                self.$notify({
                    title: self.$i18n.t('Success').toString(),
                    text: self.$i18n.t('Data saved correctly').toString(),
                    type: 'success'
                });
                self.$router.push('/modules/relatedLinks/' + response.data.relatedLink.id + '/edit');
            }).catch(function () {
                self.loading = false;
            });
        },
    }
}